import { OnboardingGoalQuestionType } from "app/pages/sales-intelligence/sub-modules/onboarding/types/enums";
import {
    SICompanyOverviewOnboardingGif,
    SIConnectMyCRM,
    SIContactProfileOnboardingGif,
    SICrmSyncOnboardingGif,
    SIEnrichCsvOnboardingGif,
    SIExtensionOnboardingGif,
    SIFindLeadsOnboardingGif,
    SISetUpAlertsOnboardingGif,
    SISetUpIntentAlertOnboardingGif,
    SIUploadListOfCompaniesOnboardingGif,
    SIUploadSuppressionListOnboardingGif,
} from "app/pages/sales-intelligence/constants/images";

export const onboardingHubImageByTaskType: Record<OnboardingGoalQuestionType, string> = {
    [OnboardingGoalQuestionType.FindNewProspects]: SIFindLeadsOnboardingGif,
    [OnboardingGoalQuestionType.SyncMyCrm]: SICrmSyncOnboardingGif,
    [OnboardingGoalQuestionType.EnrichCsvWithCompanies]: SIEnrichCsvOnboardingGif,
    [OnboardingGoalQuestionType.DownloadChromeExtension]: SIExtensionOnboardingGif,
    [OnboardingGoalQuestionType.SetUpAlerts]: SISetUpAlertsOnboardingGif,
    [OnboardingGoalQuestionType.UploadListOfCompanies]: SIUploadListOfCompaniesOnboardingGif,
    [OnboardingGoalQuestionType.SetUpIntentAlerts]: SISetUpIntentAlertOnboardingGif,
    [OnboardingGoalQuestionType.UploadSuppressionList]: SIUploadSuppressionListOnboardingGif,
    [OnboardingGoalQuestionType.CreateContactProfile]: SIContactProfileOnboardingGif,
    [OnboardingGoalQuestionType.ConnectMyCrm]: SIConnectMyCRM,
    [OnboardingGoalQuestionType.ResearchSpecificCompany]: SICompanyOverviewOnboardingGif,
};
